import { parseTakeawayVariant } from '@trackeat/shared';

export type MenuType = 'menu' | 'takeaway';
export function menuTypeFromSearch(search: string): MenuType {
  return new URLSearchParams(search).get('view') === 'takeaway' ? 'takeaway' : 'menu';
}
export function menuTables(type: MenuType) {
  return type === 'takeaway'
    ? { categories: 'menu_takeaway_categories', items: 'menu_takeaway_items' } as const
    : { categories: 'menu_categories', items: 'menu_items' } as const;
}
export function menuViewUrl(base: string, type: MenuType | 'aperitivo'): string {
  return `${base}?view=${type}`;
}

export function menuItemPriceLabel(item: { price_cents: number | null; price_unit?: string | null }): string {
  const euro = (cents: number | null): string => cents == null ? '—' : `€ ${(cents / 100).toFixed(2).replace('.', ',')}`;
  const variant = parseTakeawayVariant(item.price_unit);
  if (!variant) return euro(item.price_cents);
  return `${variant.kind === 'family' ? 'Normale' : 'Panino'} ${euro(item.price_cents)} · ${variant.kind === 'family' ? 'Famiglia' : 'Piadina'} ${euro(variant.cents)}`;
}
